module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12 sm5"
  }, [_c('qculist', {
    attrs: {
      "questions": _vm.questions,
      "selectedQuestionId": _vm.selectedQuestionId
    },
    on: {
      "updatedList": _vm.updatedList,
      "addQuestion": _vm.addQuestion,
      "questionSelected": _vm.questionSelected,
      "deleteQuestion": _vm.deleteQuestion
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm7"
  }, [_c('router-view', {
    on: {
      "createQuestion": _vm.createQuestion,
      "updateQuestion": _vm.updateQuestion
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acbef7c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrikiosk/QCUEditor.vue
// module id = 1210
// module chunks = 1